import { CURRENT_LANGUAGE_CODE } from './language.js';

const messages = {
  "en": {
    "error": "Error",
    "serverError": "Server error",
    "required": "Complete all required fields",
    "positive": "All values must be greater than zero",
    "containerRequired": "Select a container type",
    "dimensionsRequired": "Enter all package dimensions and weight",
    "unitRequired": "Select a unit of measurement",
    "quantity": "Packages that fit in the selected container:",
    "pieces": "pcs",
    "weight": "Total weight of packages in the container:",
    "kilograms": "kg",
    "ldmSingle": "LDM per pallet:",
    "ldmTotal": "Total LDM:",
    "volumeSingle": "Box volume:",
    "volumeTotal": "Total box volume:",
    "cubicMetres": "m³",
    "axleLoadsRequired": "Enter the axle loads",
    "emptyResponse": "The server returned an empty response. Check the data and try again.",
    "invalidResponse": "The server returned invalid data. Please try again.",
    "networkError": "Network error. Check your internet connection.",
    "processingError": "Unable to process the data. Please try again.",
    "details": "Details",
    "massTitle": "Mass:",
    "vehicleMass": "Vehicle combination mass:",
    "cargoMass": "Cargo mass:",
    "tractorLoads": "Tractor axle loads:",
    "tractorAxle": "Tractor axle load",
    "trailerLoads": "Semitrailer axle loads:",
    "trailerAxle": "Semitrailer axle load",
    "containerHitch": "Distance from the container to the hitch",
    "tractorHitch": "Distance from tractor axles to the hitch",
    "tractorAxlesDistance": "Distance between vehicle axles",
    "trailerAxlesDistance": "Distance between semitrailer and tractor axles",
    "trailerLength": "Semitrailer length",
    "firstAxleLoad": "Load on the first tractor axle"
  },
  "es": {
    "error": "Error",
    "serverError": "Error del servidor",
    "required": "Completa todos los campos obligatorios",
    "positive": "Todos los valores deben ser mayores que cero",
    "containerRequired": "Selecciona un tipo de contenedor",
    "dimensionsRequired": "Introduce las dimensiones y el peso de cada bulto",
    "unitRequired": "Selecciona una unidad de medida",
    "quantity": "Bultos que caben en el contenedor seleccionado:",
    "pieces": "uds.",
    "weight": "Peso total de los bultos en el contenedor:",
    "kilograms": "kg",
    "ldmSingle": "LDM por palé:",
    "ldmTotal": "LDM total:",
    "volumeSingle": "Volumen de la caja:",
    "volumeTotal": "Volumen total de las cajas:",
    "cubicMetres": "m³",
    "axleLoadsRequired": "Introduce las cargas por eje",
    "emptyResponse": "El servidor devolvió una respuesta vacía. Comprueba los datos e inténtalo de nuevo.",
    "invalidResponse": "El servidor devolvió datos no válidos. Inténtalo de nuevo.",
    "networkError": "Error de red. Comprueba tu conexión a Internet.",
    "processingError": "No se pudieron procesar los datos. Inténtalo de nuevo.",
    "details": "Detalles",
    "massTitle": "Masa:",
    "vehicleMass": "Masa del conjunto de vehículos:",
    "cargoMass": "Masa de la carga:",
    "tractorLoads": "Cargas por eje de la cabeza tractora:",
    "tractorAxle": "Carga en el eje de la cabeza tractora",
    "trailerLoads": "Cargas por eje del semirremolque:",
    "trailerAxle": "Carga en el eje del semirremolque",
    "containerHitch": "Distancia del contenedor al enganche",
    "tractorHitch": "Distancia de los ejes de la tractora al enganche",
    "tractorAxlesDistance": "Distancia entre los ejes del vehículo",
    "trailerAxlesDistance": "Distancia entre los ejes del semirremolque y la tractora",
    "trailerLength": "Longitud del semirremolque",
    "firstAxleLoad": "Carga en el primer eje de la tractora"
  },
  "pt": {
    "error": "Erro",
    "serverError": "Erro do servidor",
    "required": "Preencha todos os campos obrigatórios",
    "positive": "Todos os valores devem ser superiores a zero",
    "containerRequired": "Selecione um tipo de contentor",
    "dimensionsRequired": "Introduza as dimensões e o peso da embalagem",
    "unitRequired": "Selecione uma unidade de medida",
    "quantity": "Embalagens que cabem no contentor selecionado:",
    "pieces": "un.",
    "weight": "Peso total das embalagens no contentor:",
    "kilograms": "kg",
    "ldmSingle": "LDM por palete:",
    "ldmTotal": "LDM total:",
    "volumeSingle": "Volume da caixa:",
    "volumeTotal": "Volume total das caixas:",
    "cubicMetres": "m³",
    "axleLoadsRequired": "Introduza as cargas por eixo",
    "emptyResponse": "O servidor devolveu uma resposta vazia. Verifique os dados e tente novamente.",
    "invalidResponse": "O servidor devolveu dados inválidos. Tente novamente.",
    "networkError": "Erro de rede. Verifique a ligação à Internet.",
    "processingError": "Não foi possível processar os dados. Tente novamente.",
    "details": "Detalhes",
    "massTitle": "Massa:",
    "vehicleMass": "Massa do conjunto de veículos:",
    "cargoMass": "Massa da carga:",
    "tractorLoads": "Cargas por eixo do trator:",
    "tractorAxle": "Carga no eixo do trator",
    "trailerLoads": "Cargas por eixo do semirreboque:",
    "trailerAxle": "Carga no eixo do semirreboque",
    "containerHitch": "Distância do contentor ao engate",
    "tractorHitch": "Distância dos eixos do trator ao engate",
    "tractorAxlesDistance": "Distância entre os eixos do veículo",
    "trailerAxlesDistance": "Distância entre os eixos do semirreboque e do trator",
    "trailerLength": "Comprimento do semirreboque",
    "firstAxleLoad": "Carga no primeiro eixo do trator"
  },
  "br": {
    "error": "Erro",
    "serverError": "Erro do servidor",
    "required": "Preencha todos os campos obrigatórios",
    "positive": "Todos os valores devem ser maiores que zero",
    "containerRequired": "Selecione um tipo de contêiner",
    "dimensionsRequired": "Informe as dimensões e o peso da embalagem",
    "unitRequired": "Selecione uma unidade de medida",
    "quantity": "Embalagens que cabem no contêiner selecionado:",
    "pieces": "un.",
    "weight": "Peso total das embalagens no contêiner:",
    "kilograms": "kg",
    "ldmSingle": "LDM por palete:",
    "ldmTotal": "LDM total:",
    "volumeSingle": "Volume da caixa:",
    "volumeTotal": "Volume total das caixas:",
    "cubicMetres": "m³",
    "axleLoadsRequired": "Informe as cargas por eixo",
    "emptyResponse": "O servidor retornou uma resposta vazia. Confira os dados e tente novamente.",
    "invalidResponse": "O servidor retornou dados inválidos. Tente novamente.",
    "networkError": "Erro de rede. Verifique sua conexão com a internet.",
    "processingError": "Não foi possível processar os dados. Tente novamente.",
    "details": "Detalhes",
    "massTitle": "Massa:",
    "vehicleMass": "Massa do conjunto de veículos:",
    "cargoMass": "Massa da carga:",
    "tractorLoads": "Cargas por eixo do cavalo mecânico:",
    "tractorAxle": "Carga no eixo do cavalo mecânico",
    "trailerLoads": "Cargas por eixo do semirreboque:",
    "trailerAxle": "Carga no eixo do semirreboque",
    "containerHitch": "Distância do contêiner ao engate",
    "tractorHitch": "Distância dos eixos do cavalo mecânico ao engate",
    "tractorAxlesDistance": "Distância entre os eixos do veículo",
    "trailerAxlesDistance": "Distância entre os eixos do semirreboque e do cavalo mecânico",
    "trailerLength": "Comprimento do semirreboque",
    "firstAxleLoad": "Carga no primeiro eixo do cavalo mecânico"
  },
  "ru": {
    "error": "Ошибка",
    "serverError": "Ошибка сервера",
    "required": "Заполните все обязательные поля",
    "positive": "Все значения должны быть больше нуля",
    "containerRequired": "Выберите тип контейнера",
    "dimensionsRequired": "Заполните все поля размеров и веса упаковки",
    "unitRequired": "Выберите единицу измерения",
    "quantity": "Количество упаковок, которое помещается в выбранный контейнер:",
    "pieces": "шт",
    "weight": "Суммарный вес упаковок, которые помещаются в контейнер:",
    "kilograms": "кг",
    "ldmSingle": "LDM одного поддона:",
    "ldmTotal": "Общий LDM всех поддонов:",
    "volumeSingle": "Объем коробки:",
    "volumeTotal": "Общий объем коробок:",
    "cubicMetres": "м³",
    "axleLoadsRequired": "Заполните данные о нагрузках на оси",
    "emptyResponse": "Сервер вернул пустой ответ. Проверьте правильность данных и попробуйте снова.",
    "invalidResponse": "Сервер вернул некорректные данные. Попробуйте снова.",
    "networkError": "Ошибка сети. Проверьте подключение к интернету.",
    "processingError": "Ошибка обработки данных. Попробуйте еще раз.",
    "details": "Подробности",
    "massTitle": "Масса:",
    "vehicleMass": "Масса автопоезда:",
    "cargoMass": "Масса груза:",
    "tractorLoads": "Нагрузка на оси тягача:",
    "tractorAxle": "Нагрузка на ось тягача",
    "trailerLoads": "Нагрузка на оси полуприцепа:",
    "trailerAxle": "Нагрузка на ось полуприцепа",
    "containerHitch": "Расстояние от контейнера до сцепки",
    "tractorHitch": "Расстояние от осей тягача до сцепки",
    "tractorAxlesDistance": "Расстояние между осями машины",
    "trailerAxlesDistance": "Расстояние от осей полуприцепа до осей тягача",
    "trailerLength": "Длина полуприцепа",
    "firstAxleLoad": "Нагрузка на первую ось тягача"
  }
};

export function calculatorText(key, language = CURRENT_LANGUAGE_CODE) {
  return (messages[language] || messages.en)[key] || messages.en[key];
}

export function formatCalculatorNumber(value, options = {}, language = CURRENT_LANGUAGE_CODE) {
  const locale = { en: 'en-US', es: 'es-ES', pt: 'pt-PT', br: 'pt-BR', ru: 'ru-RU' }[language] || 'en-US';
  return new Intl.NumberFormat(locale, options).format(value);
}
